module.exports = __webpack_public_path__ + "static/media/sec.a4894d50.svg";